import { makeAutoObservable } from 'mobx'
import { type IResponseCreditUsageAnalyticsDetailsItem } from 'entities/Analytics/api/types'

export class CreditUsage {
  id: number
  agent_name: string | null
  organization_id: number
  type: string
  object_id: number
  object_model: string
  object_vendor_id: string
  object_event_type: string
  title: string
  amount: string
  inversed_amount: number
  meta: string
  processed_at: string
  chatbot_name: string | null
  details?: IResponseCreditUsageAnalyticsDetailsItem['details']

  constructor(data: IResponseCreditUsageAnalyticsDetailsItem) {
    this.id = data.id
    this.agent_name = data.agent_name
    this.organization_id = data.organization_id
    this.type = data.type
    this.object_id = data.object_id
    this.object_model = data.object_model
    this.object_vendor_id = data.object_vendor_id
    this.object_event_type = data.object_event_type
    this.title = data.title
    this.amount = data.amount
    this.inversed_amount = data.inversed_amount
    this.meta = data.meta
    this.processed_at = data.processed_at
    this.chatbot_name = data.chatbot_name
    this.details = data.details

    makeAutoObservable(this)
  }
}
